import { endpointsAssets } from "lib/actions/endpoints/endpointsAssets";
import { authenticatedAxios } from "../fetcher";
import { AssetModel } from "lib/types/assets/AssetModel";

export function registerAssetUpload(
  projectId: number,
  fileName: string,
  fileSize: number,
  claimedAssetType?: AssetModel["type"],
) {
  return authenticatedAxios
    .request<{ uploadId: number }>({
      ...endpointsAssets.uploadRegister,
      data: {
        projectId,
        fileName,
        fileSize,
        claimedAssetType,
      },
    })
    .then((r) => r.data);
}
